import React from 'react';
import xtforge from '../assets/images/xtforge.png';
import APP from '../modules/index';
import { Link } from 'react-router-dom';
import { OpenCloseHoc } from '../hoc/index';

export const headerView = (props) => {
  const TestDataManagement = localStorage.getItem('TestDataManagement');
  const TestDesign = localStorage.getItem('TestDesign');
  const superAdminRole =
    localStorage.getItem('role') === 'SUPERADMIN' ? false : true;
  let homeurl;
  if (TestDataManagement === 'true' && TestDesign === 'true') {
    homeurl = APP.Constants.ROUTES.HOME;
  } else {
    homeurl = APP.Constants.ROUTES.DESIGN_HOME;
  }
  return (
    <header className='header plr-20'>
      {/* <div className='versionchange'>v {APP.Constants.ROUTES.VERSION}</div> */}
      <div className='logo'>
        <div className='logo__link'>
          <img src={xtforge} alt='logo' className='logo__link__img' />
        </div>
      </div>
      <div className='header__divider'></div>
      {superAdminRole && (
        <div className='user homenav'>
          <div className='user__info'>
            <Link to={homeurl}>
              <div className='user__info__title'>
                <div className='user__info__title__label homenav-cls'>
                  Go Home
                </div>
              </div>
            </Link>
          </div>
        </div>
      )}
      {printUserInfo(props)}
    </header>
  );
};

const printUserInfo = (payload) => {
  const { onLogout } = payload;
  const username = localStorage.getItem('username');
  return (
    <OpenCloseHoc
      render={(props) => {
        const { isOpen, onHandleClick, ref } = props;

        return (
          <div className='user' ref={ref}>
            <div className='user__info' onClick={onHandleClick}>
              <div className='user__info__title'>
                <div className='user__info__title__label'>
                  {username || 'User'}
                </div>
                <div className='user__info__title__icon'>
                  <i className={`fa fa-chevron-${isOpen ? 'up' : 'down'}`}></i>
                </div>
              </div>
            </div>
            <ul
              className={`user__dropdown ${
                isOpen ? 'user__dropdown--open' : ''
              }`}
            >
              {/* {superAdmin ? (
                <>
                  {TestDesign === 'true' && (
                    <Link
                      className={
                        enabledFlag
                          ? 'table__row__td--actions--disabled remove__underline '
                          : 'user__removeline'
                      }
                      to={`${TestConfig}`}
                    >
                      <li className='user__dropdown__item user__dropdown__color'>
                        <div className='user__dropdown__item__icon'>
                          <i className='fa fa-id-card-o'></i>
                        </div>
                        <div className='user__dropdown__item__label'>
                          Test Design
                        </div>
                      </li>
                    </Link>
                  )}
                  {TestData === 'true' && (
                    <Link
                      className={
                        enabledFlag
                          ? 'table__row__td--actions--disabled remove__underline '
                          : 'user__removeline'
                      }
                      to={`${TestDataManagement}`}
                    >
                      <li className='user__dropdown__item user__dropdown__color'>
                        <div className='user__dropdown__item__icon'>
                          <i className='fa fa-user-circle-o'></i>
                        </div>
                        <div className='user__dropdown__item__label'>
                          Test Data Generation
                        </div>
                      </li>
                    </Link>
                  )}
                </>
              ) : (
                ''
              )} */}
              <li
                className='user__dropdown__item user__dropdown__color'
                onClick={onLogout}
              >
                <div className='user__dropdown__item__icon'>
                  <i className='fa fa-sign-out'></i>
                </div>
                <div className='user__dropdown__item__label'>logout</div>
              </li>
            </ul>
          </div>
        );
      }}
    />
  );
};
